import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodFood: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h2v4h1V0h2v4c0 1.48-.804 2.773-2 3.465V16H2V7.465A4 4 0 0 1 0 4V0h2v4h1zm13 12c0-1.48-.804-2.773-2-3.465V0h-4v8.535A4 4 0 1 0 16 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodFood
